import front from './Front/front';
import management from './Management/management';
import { createSocketSynchronizer } from './Synchronization/SocketSynchronizer/socketSynchronizerFactory';
import { createSameThreadWebWorkerFactory } from './WebWorker/masterWebWorkerFactory';
import { createDefaultDrivers } from './NativeDevice/Default/defaultDriverFactory';
import { parameters } from './options';
import { registerServiceWorker } from './ServiceWorker/serviceWorkerLoader';
import { getApplicationVersion, getSubscriptionType } from './helper';

(async () => {
	const serviceWorkerRegistration = await registerServiceWorker(window);
	if (parameters.bundledApplet !== null && !parameters.autoVerification?.organizationUid) {
		throw new Error('sOS Open requires organization uid to be set during build.'); // TODO add more info, link, etc.
	}
	const autoVerification = parameters.autoVerification ? { organizationUid: parameters.autoVerification.organizationUid } : undefined;
	const subscriptionType = getSubscriptionType();

	const { frontDriver, managementDriver, cacheDriver } = createDefaultDrivers(window, serviceWorkerRegistration?.scope);
	await frontDriver.initialize(parameters.url.staticBaseUrl);
	await managementDriver.initialize(parameters.url.staticBaseUrl);
	const synchronizer = createSocketSynchronizer(parameters.url.synchronizerServerUrl, () => frontDriver);

	const webWorkerFactory = createSameThreadWebWorkerFactory();

	const commonOptions = {
		socketName: 'front' as const,
		global: window,
		configUrls: parameters.url.configUrls,
		platformUri: parameters.url.socketUri,
		staticBaseUrl: parameters.url.staticBaseUrl,
		uploadBaseUrl: parameters.url.uploadBaseUrl,
		checkInterval: parameters.app.checkIntervalMs,
		publicKey: parameters.httpAuthPublicKey,
		sessionIdKey: parameters.app.sessionIdKey,
		frontAppletPrefix: parameters.frontApplet.prefix,
		frontDisplayVersion: parameters.app.version,
		weinreServerUrl: parameters.url.weinreServerUrl,
		extendedManagementUrl: null,
		nativeDriver: { frontDriver, cacheDriver, managementDriver },
		managementDriver: managementDriver,
		synchronizer,
		webWorkerFactory,
		applicationVersion: getApplicationVersion(),
		bundledApplet: parameters.bundledApplet,
		autoVerification,
		excludedResponsibilities: [],
		subscriptionType,
		bundledServlet: null,
	};
	const frontOptions = { ...commonOptions, shortAppletFilesUrl: false };

	await front(frontOptions);
	await management(commonOptions);
})().catch((error: any) => console.error(error));
